export class PharmacyBarcodeReader {
    identifiers = ['C', 'R', 'SI', 'SK', 'SB', 'SS'];
    decoders = {
        C: { type: 'Container', values: ['containerId'] },
        R: {
            type: 'PatientDose', values: ['rxNum', 'orderNum', 'fillingPharm', 'patientName', 'productForm',
                'activity', 'activityUom', 'volume', 'volumeUom', 'calTime', 'expTime', 'customerShipTo']
        },
        SI: { type: 'Inventory', values: ['lotNum', 'customerShipTo', 'productForm'] },
        SK: { type: 'CompoundBulkDose', values: ['lotNum', 'customerShipTo'] },
        SB: { type: 'WasteBin', values: ['binId', 'customerShipTo'] },
        SS: { type: 'SealedSource', values: ['lotNum', 'customerShipTo', 'productForm'] }
    };

    // this.register {
    //     barcodeReader.register(self);
    // }

    canDecode(content) {
        return (this.identifiers.indexOf(content.split("|")[0]) != -1) ? true : false;
    }

    decode(content) {
        var cutContent = content.split("|");
        var decodedOutput = null;
        var decoder = this.decoders[cutContent[0]];
        if (decoder) {
            decodedOutput = { type: decoder.type };
            decoder.values.forEach((value, index) => {
                decodedOutput[value] = cutContent[index + 1];
            });
        }
        return decodedOutput;
    }
}

// new PharmacyBarcodeReader().register();
